import { useState } from 'react';

type ViewType = 'list' | 'create' | 'edit' | 'detail';

export const useBudgetView = () => {
  const [view, setView] = useState<ViewType>('list');
  const [currentBudgetId, setCurrentBudgetId] = useState<string | null>(null);

  const goToList = () => {
    setView('list');
    setCurrentBudgetId(null);
  };

  const goToCreate = (budgetId: string) => {
    setCurrentBudgetId(budgetId);
    setView('create');
  };

  const goToEdit = (budgetId: string) => {
    setCurrentBudgetId(budgetId);
    setView('edit');
  };

  const goToDetail = (budgetId: string) => {
    setCurrentBudgetId(budgetId);
    setView('detail');
  };

  return {
    view,
    currentBudgetId,
    goToList,
    goToCreate,
    goToEdit,
    goToDetail,
  };
};
